import api from '../../api';
import { socket } from './../store/socket';

export const reportSchemasStartRequest = () => {
  return {
    type: 'REPORT_SCHEMAS_START_REQUEST'
  };
};

export const reportSchemasEndRequest = () => {
  return {
    type: 'REPORT_SCHEMAS_END_REQUEST'
  };
};

export const getAllReportSchemasSuccess = ({ data }) => {
  return {
    type: 'REPORT_SCHEMAS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllReportSchemasError = error => {
  return {
    type: 'REPORT_SCHEMAS_GET_ALL_ERROR',
    payload: error
  };
};

export const addReportSchemasSuccess = ({ data }) => {
  return {
    type: 'REPORT_SCHEMAS_ADD_SUCCESS',
    payload: data
  };
};

export const addReportSchemasError = error => {
  return {
    type: 'REPORT_SCHEMAS_ADD_ERROR',
    payload: error
  };
};

export const editReportSchemasSuccess = ({ data }) => {
  return {
    type: 'REPORT_SCHEMAS_EDIT_SUCCESS',
    payload: data
  };
};

export const editReportSchemasError = error => {
  return {
    type: 'REPORT_SCHEMAS_EDIT_ERROR',
    payload: error
  };
};

export const removeReportSchemasSuccess = id => {
  return {
    type: 'REPORT_SCHEMAS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeReportSchemasError = error => {
  return {
    type: 'REPORT_SCHEMAS_REMOVE_ERROR',
    payload: error
  };
};

export const removeReportSchemasOnly = id => {
  return {
    type: 'REPORT_SCHEMAS_REMOVE_ONLY',
    payload: id
  };
};

export const reportSchemasModifyStore = ({ data }) => {
  return {
    type: 'REPORT_SCHEMAS_MODIFY_STORE',
    payload: data
  };
};

export const addReportSchemas = (data, formReset) => {
  return async dispatch => {
    try {
      dispatch(reportSchemasStartRequest());
      const response = await api().post('/api/report_schemas', data);
      dispatch(addReportSchemasSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'reportSchemas',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addReportSchemasError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(reportSchemasEndRequest());
      }, 1800);
    }
  };
};

export const getAllReportSchemas = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(reportSchemasStartRequest());
      const response = await api().get('/api/report_schemas', { params });
      dispatch(getAllReportSchemasSuccess(response));
    } catch (err) {
      dispatch(getAllReportSchemasError(err));
    } finally {
      dispatch(reportSchemasEndRequest());
    }
  };
};

export const editReportSchemas = (data, callback) => {
  return async dispatch => {
    try {
      dispatch(reportSchemasStartRequest());
      const id = data._id;
      const response = await api().put('/api/report_schemas/' + id, data);
      dispatch(editReportSchemasSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'reportSchemas',
        data: [response.data]
      });
      callback();
    } catch (err) {
      dispatch(editReportSchemasError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(reportSchemasEndRequest());
      }, 1800);
    }
  };
};

export const removeReportSchemas = (id, callback) => {
  return async dispatch => {
    try {
      dispatch(reportSchemasStartRequest());
      await api().delete('/api/report_schemas/' + id);
      dispatch(removeReportSchemasSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'reportSchemas',
        data: id
      });
      callback();
    } catch (err) {
      dispatch(removeReportSchemasError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(reportSchemasEndRequest());
      }, 1800);
    }
  };
};
